import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import {
  completarOnboarding,
  getMe,
  getStoredEmail,
  guardarPasoOnboarding,
  solicitarLoginLink,
  verificarLoginLink,
  logout as logoutApi,
} from "../lib/accountsApi";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [account, setAccount] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [errorBoot, setErrorBoot] = useState(null);

  const refrescar = useCallback(async () => {
    const email = getStoredEmail();
    if (!email) {
      setAccount(null);
      return null;
    }
    try {
      const data = await getMe();
      setAccount(data);
      return data;
    } catch (err) {
      console.warn("auth_refresh_error", err?.message || err);
      setAccount(null);
      return null;
    }
  }, []);

  useEffect(() => {
    let cancelado = false;
    (async () => {
      try {
        await refrescar();
      } catch (err) {
        if (!cancelado) setErrorBoot(err);
      } finally {
        if (!cancelado) setCargando(false);
      }
    })();
    return () => {
      cancelado = true;
    };
  }, [refrescar]);

  const solicitarLink = useCallback(async (email, opts) => {
    return solicitarLoginLink(email, opts);
  }, []);

  const verificarLink = useCallback(async (email, token) => {
    const data = await verificarLoginLink(email, token);
    setAccount(data);
    return data;
  }, []);

  const logout = useCallback(() => {
    logoutApi();
    setAccount(null);
  }, []);

  const guardarPaso = useCallback(async (n, payload) => {
    const data = await guardarPasoOnboarding(n, payload);
    setAccount(data);
    return data;
  }, []);

  const completar = useCallback(async () => {
    const data = await completarOnboarding();
    setAccount(data);
    return data;
  }, []);

  const value = useMemo(
    () => ({
      account,
      cargando,
      errorBoot,
      isAuthenticated: !!account?.email,
      onboardingCompleto: !!account?.onboarding?.completado,
      solicitarLink,
      verificarLink,
      logout,
      refrescar,
      guardarPaso,
      completar,
    }),
    [
      account,
      cargando,
      errorBoot,
      solicitarLink,
      verificarLink,
      logout,
      refrescar,
      guardarPaso,
      completar,
    ],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth debe usarse dentro de AuthProvider");
  }
  return ctx;
}
